import React from "react";
import { Box } from '@mui/material';
import { Header } from '../../components/header';
import { Help, Time, User } from '../../components/header/components';
import AdminAccordion from '../../components/admin/admin-accordion';
import useStyles from './styles';

const Admin = () => {
  const pageHeader = 'Administration';
  const classes = useStyles();

  return (
    <>
      <Header title={pageHeader}
        headerComponents={[<Help userLink="/SitePages/Administration-Manual.aspx?promotedState=0" />, <Time suppressPopover />, <User />]}
      />
      <Box className={classes.scrollBox}>
        <AdminAccordion />
      </Box>
    </>
  );
};

export default Admin;
